import React, { Component } from 'react';
import { LtMaxPrice } from '~/Api/User/ProductGroup/LtMaxPrice';
import { formatCountriesError } from '~/UI';
import CountryIcon from '~/UI/CountryIcon';
import Heading from '~/UI/Heading';

import styles from './styles.less';

interface Props {
	ltMaxPrice: LtMaxPrice;
	formatPercentage(percentage: number): string;
}

export default class Calculation extends Component<Props> {
	public render() {
		const {
			ltMaxPrice: { finalCalculation },
			formatPercentage,
		} = this.props;

		return (
			<div className={styles.container}>
				<div className={styles.columns}>
					<div className={styles.leftColumn}>
						<Heading level={3}>Lowest ex-factory prices:</Heading>
						{finalCalculation.gesvisPrice?.fromProducts.map((product, i) => (
							<div
								className={styles.row}
								data-product-id={product.id}
								data-testid={`lowest-exfactory-price-${i}`}
								key={product.id}
							>
								<span className={styles.number}>{i + 1}.</span>

								<span className={styles.countryIcon}>
									<CountryIcon code={product.dataSource.country.alpha2} name={product.dataSource.country.name} />
								</span>

								<span className={styles.countryDescription}>
									{product.dataSource.country.alpha2}
									<br />
									{product.dataSource.shortName}
								</span>
							</div>
						))}
					</div>
					<div className={styles.centerColumn}>
						<Heading level={3}>Calculated max price:</Heading>

						<div className={styles.row}>
							<p className={styles.rowName}>Calculated GESvid price (average of 3 lowest):</p>
							<p className={styles.rowValue}>
								{finalCalculation.gesvisPrice !== null ? (
									<strong>{finalCalculation.gesvisPrice.price.roundedHumanFormat()}</strong>
								) : null}
							</p>
						</div>

						{finalCalculation.emptyResultReason.length > 0 ? (
							<div className={styles.row}>
								<p>{this.renderEmptyResultReason()}</p>
							</div>
						) : null}
					</div>
					<div className={styles.rightColumn}>
						<Heading level={3}>&nbsp;</Heading>

						<div className={styles.row}>
							<p className={styles.smallRowName}>
								Current declared price
								{finalCalculation.referencedProduct !== null
									? ` (${finalCalculation.referencedProduct?.dataSource.shortName})`
									: null}
								:
							</p>
							<p className={styles.smallRowValue}>
								<strong>{finalCalculation.referencedProduct?.currentExFactoryPrice?.roundedHumanFormat()}</strong>
							</p>
						</div>

						<div className={styles.row}>
							<p className={styles.smallRowName}>Potential price drop</p>
							<p className={styles.smallRowValue}>
								{finalCalculation.priceDropPercents !== null
									? formatPercentage(finalCalculation.priceDropPercents)
									: null}
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}

	private renderEmptyResultReason() {
		const {
			ltMaxPrice: { finalCalculation },
		} = this.props;
		const countryError = finalCalculation.findMaxOneReferenceProductError();

		if (finalCalculation.hasMissingProductSettings()) {
			return <strong className={styles.rowError}>Some products settings are missing</strong>;
		}
		if (finalCalculation.requiresMinOneReferenceProductErrorCode()) {
			return <strong className={styles.rowError}>Calculation requires at least one reference country product</strong>;
		}
		if (countryError !== null) {
			return (
				<strong className={styles.rowError}>
					Calculation requires at most one product for each reference country
					{formatCountriesError(countryError.duplicateCountries)}
				</strong>
			);
		}
		if (finalCalculation.isMissingReferenceSettings()) {
			return <strong className={styles.rowError}>Calculation requires reference settings</strong>;
		}
		if (finalCalculation.isIllegalProductPriceTypeSelected()) {
			return <strong className={styles.rowError}>Some products have illegal price selected</strong>;
		}
		return null;
	}
}
